import { Grid } from '@mui/material'
import styled from 'styled-components'

export const ContainerPosts = styled(Grid)`
  @media screen and (max-width: 600px) {
    padding: 0 8px 0 8px;
  }
`
